import React from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import styles from "./Reason.module.scss";
import axiosClient from "../../service/axios";
import { toast } from "react-toastify";

function Override({ override, setOverride, selectedOverride }) {
    // console.log("selectedOverride", selectedOverride);

  const handleModalClose = () => {
    setOverride(false);
  };

  const handleOverride = async () => {
    try {
      const response = await axiosClient.put(
        `/lite/v2/api/admin/vendor/override`,
        {
          title: selectedOverride?.title,
          order_id: selectedOverride?.order_id,
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        setOverride(false);
      }
    } catch (error) {
      if (error.response.status === 400) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <Dialog open={override} onClose={handleModalClose}>
      <DialogContent style={{ paddingBottom: "0" }}>
        <div className={styles.title}>Override</div>

        <div className={styles.formContainer}>
          You are about to overwrite vendor acceptance of this order
        </div>
      </DialogContent>

      <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
        <div
          style={{
            cursor: "pointer",
            color: "#ffffff",
            backgroundColor: "#78A55A",
            padding: "10px",
            borderRadius: "3px",
            border: "1px solid #DFE1E6",
            fontSize: "14px",
          }}
          onClick={handleOverride}
        >
          Yes
        </div>

        <div
          style={{
            cursor: "pointer",
            color: "#ffffff",
            backgroundColor: "#b70303",
            padding: "10px",
            borderRadius: "3px",
            border: "1px solid #DFE1E6",
            fontSize: "14px",
          }}
          onClick={handleModalClose}
        >
          No
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default Override;
